const DEFAULT_DATE_FORMAT = 'DD MMM YYYY'

const dateFormatFilter = function (moment) {
  'ngInject'
  return function (time, format = DEFAULT_DATE_FORMAT) {
    return moment(time).format(format)
  }
}
export default dateFormatFilter
